import {
  CONSOLIDATED_DATA,
  HISTORY_TABLE_DATA,
  INUM_FILTER,
  LOADER_STATUS,
  RECEIPIENT_GSTIN_FILTER,
  REJECTED_DATA,
  SELECTED_FROM_DATE,
  SELECTED_GSTIN_HISTORY,
  SELECTED_HISTORY,
  SELECTED_TO_DATE,
  SUMMARY_TABLE_DATA,
  SUPPLIER_GSTIN_FILTER,
  TOTAL_PAGES_HISTORY,
  TOTAL_PAGES_REJECTED,
  VIEW_TABLE_DATA,
} from "./constants";

export const initialState = {
  loaderStatus: false,
  supplierGstinFilter: [],
  receipientGstinFilter: [],
  inumFilter: [],
  selectedFromDate: "",
  selectedToDate: "",
  summaryTableData: [],
  viewTableData: [],
  historyTableData: [],
  selectedHistory:[],
  selectedGstinHistory:[],
  consolidatedData:[],
  rejectedData:[],
  totalPagesRejected:1,
  totalPagesHistory:1,
};

/* eslint-disable default-case, no-param-reassign */
const imsRecoOutwardReducer = (state = initialState, action) => {
  switch (action.type) {
    case LOADER_STATUS:
      return {
        ...state,
        loaderStatus: action.loaderStatus,
      };
    case SUPPLIER_GSTIN_FILTER:
      return {
        ...state,
        supplierGstinFilter: action.supplierGstinFilter,
      };
    case RECEIPIENT_GSTIN_FILTER:
      return {
        ...state,
        receipientGstinFilter: action.receipientGstinFilter,
      };
    case SELECTED_FROM_DATE:
      return {
        ...state,
        selectedFromDate: action.selectedFromDate,
      };
    case SELECTED_TO_DATE:
      return {
        ...state,
        selectedToDate: action.selectedToDate,
      };
    case INUM_FILTER:
      return {
        ...state,
        inumFilter: action.inumFilter,
      };
    case HISTORY_TABLE_DATA:
      return {
        ...state,
        historyTableData: action.historyTableData,
      };
    case SUMMARY_TABLE_DATA:
      return {
        ...state,
        summaryTableData: action.summaryTableData,
      };
    case VIEW_TABLE_DATA:
      return {
        ...state,
        viewTableData: action.viewTableData,
      };
      case CONSOLIDATED_DATA:
      return {
        ...state,
        consolidatedData: action.consolidatedData,
      };
       case REJECTED_DATA:
      return {
        ...state,
        rejectedData: action.rejectedData,
      };
      case SELECTED_HISTORY:
      return {
        ...state,
        selectedHistory: action.selectedHistory,
      };
      case SELECTED_GSTIN_HISTORY:
      return {
        ...state,
        selectedGstinHistory: action.selectedGstinHistory,
      };
      case TOTAL_PAGES_REJECTED:
      return {
        ...state,
        totalPagesRejected: action.totalPagesRejected,
      };
      case TOTAL_PAGES_HISTORY:
      return {
        ...state,
        totalPagesHistory: action.totalPagesHistory,
      };
    default:
      return state;
  }
};

export default imsRecoOutwardReducer;
